import { Spinner } from '@amzn/awsui-components-react';

export const Loading = () => {
    return <Spinner size="large" />;
};
